// removed by extract-text-webpack-plugin
module.exports = {"Container":"table__Container__1prD0"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Stats/table.css
// module id = 1673
// module chunks = 2